export default {
  addWordToDictionaryState(state, wordData) {
    state.words = [...state.words, wordData];
  },
  setDictionaryWordLoadingState(state, data) {
    state.wordsLoading = {...state.wordsLoading, ...data};
  },
};
